import { Link } from 'react-router-dom';

const SOCIALS = [
  { icon: 'ri-weibo-line', label: '微博' },
  { icon: 'ri-wechat-line', label: '微信' },
  { icon: 'ri-youtube-line', label: '视频号' },
  { icon: 'ri-mail-line', label: '邮箱' },
];

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-800 text-primary-100">
      <div className="px-4 py-12 md:px-6">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="text-base font-bold text-background-50">北条麻妃电影</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              专注整理与分享北条麻妃的影视作品信息，提供作品大全、剧情介绍与最新影视资讯，为影迷打造清晰、易用的查询平台。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {SOCIALS.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-700 text-primary-100 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:gap-16">
            <div>
              <h4 className="text-sm font-semibold text-background-50">浏览</h4>
              <ul className="mt-4 flex flex-col gap-2.5 text-sm">
                <li>
                  <Link to="/" className="text-primary-200 transition-colors hover:text-accent-300">
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category"
                    className="text-primary-200 transition-colors hover:text-accent-300"
                  >
                    电影分类
                  </Link>
                </li>
                <li>
                  <Link
                    to="/news"
                    className="text-primary-200 transition-colors hover:text-accent-300"
                  >
                    资讯动态
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-primary-200 transition-colors hover:text-accent-300"
                  >
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50">热门类型</h4>
              <ul className="mt-4 flex flex-col gap-2.5 text-sm">
                {['剧情', '爱情', '悬疑', '历史'].map((g) => (
                  <li key={g}>
                    <Link
                      to={`/category?genre=${encodeURIComponent(g)}`}
                      className="text-primary-200 transition-colors hover:text-accent-300"
                    >
                      {g}片
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <h4 className="text-sm font-semibold text-background-50">联系我们</h4>
              <ul className="mt-4 flex flex-col gap-2.5 text-sm">
                <li className="flex items-center gap-2 text-primary-200">
                  <i className="ri-mail-line"></i>
                  contact@bh-movie.example
                </li>
                <li className="flex items-center gap-2 text-primary-200">
                  <i className="ri-map-pin-line"></i>
                  日本 · 东京
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-700 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2024 北条麻妃电影 · 本站为影迷资讯展示平台，所有资料均为演示样例。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>图片均为示意，仅供学习参考</span>
            <span className="hidden sm:inline">·</span>
            <span>内容遵循相关法律法规</span>
          </p>
        </div>
      </div>
    </footer>
  );
}